import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { modelOf } from '../../prop-types';
import OrderStore from '../../store/OrderStore';
import ConfigStore from '../../store/ConfigStore';
import Helmet from 'react-helmet-async';

@observer
class ShopAlike extends Component {
  getPIScript = () => {
    const { configStore, orderStore } = this.props;
    const { currentOrder } = orderStore;

    const ids = currentOrder
      ? currentOrder.products.map((product) => "'" + product.product_id + "'")
      : [];
    const prices = currentOrder
      ? currentOrder.products.map((product) => "'" + product.total_price + "'")
      : [];

    return (
      <script type="text/javascript">
        {`var vmt_pi = {
          'trackingId': '${configStore.shopAlike.id}',
          'version' : 'a_0.0.1',
          'type' : 'confirmed',
          'amount' : ${currentOrder.real_total},
          'skus' : [${ids}],
          'prices' : [${prices}],
          'currency' : '${currentOrder.currency}'
        };`}
      </script>
    );
  };

  render() {
    const { configStore, orderStore } = this.props;
    const { currentOrder } = orderStore;

    if (!configStore.shopAlike.enabled) {
      return null;
    }
    if (!currentOrder || currentOrder.is_seen) {
      return null;
    }

    const mainScript = (
      <script type="text/javascript">
        {`var vmt = {};
          (function(d, p) {
            var vmtr = d.createElement('script');
            vmtr.type = 'text/javascript';
            vmtr.async = true;
            var cachebuster = Math.round(new Date().getTime() / 1000);
            vmtr.src = ('https:' == p ? 'https' : 'http') + '://www.shopalike.fi/controller/visualMetaTrackingJs?cb=' + cachebuster;
            var s = d.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(vmtr, s);
          })(document, document.location.protocol);`}
      </script>
    );

    return (
      <Helmet>
        {this.getPIScript()}
        {mainScript}
      </Helmet>
    );
  }
}

ShopAlike.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  orderStore: modelOf(OrderStore).isRequired
};

export default inject('configStore', 'orderStore')(ShopAlike);



// WEBPACK FOOTER //
// ./src/analytics/ShopAlike/index.jsx